// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20oHe","title":"styles_title__3o0Ud"};